
export const costDeduction = [
    { text: '100% KUP', value: 100 },
    { text: '75% KUP', value: 75 },
    { text: '20% KUP', value: 20 },
    { text: 'NKUP', value: 0 },
];